@if (!cerrixTab.showLoader) {
    <div
        menuSystem
        [cerrixTab]="cerrixTab"
        class="details"
        (changeEvent)="handleMenuItemClick($event)"
        data-uiid="audit-detail-page"
    >
        <div class="detail-page-action-bar">
            @if (permissions.canEdit) {
                <button class="btn btn-cerrix" (click)="save()" data-uiid="save-audit">
                    <i class="fas fa-save"></i>
                    <span data-uiid="save" class="d-none d-lg-inline">{{
                        'detail.saveAudit' | t
                    }}</span>
                </button>
            }

            @if (auditModel.id > 0) {
                <span class="date-edited">
                    Last save: {{ dateModifiedPromise | async | dateTimeFormat }}
                </span>
            }
            @if (workflowButtonConfig) {
                <div class="workflow-area">
                    <span class="workflow-description">
                        {{ 'detail.workflowStatus' | t }}
                        <b data-uiid="audit-workflow-status">{{
                            workflowButtonConfig.currentStatus
                        }}</b>
                    </span>
                    <span>
                        @if (workflowButtonConfig.showNegativeButton) {
                            <button
                                data-uiid="audit-negative-workflow-button"
                                class="btn"
                                [class.btn-dark]="workflowButtonConfig.negativeButtonDarkColor"
                                [class.btn-danger]="!workflowButtonConfig.negativeButtonDarkColor"
                                (click)="onWorkflowButtonClick(false)"
                            >
                                {{ workflowButtonConfig.negativeButtonText }}
                            </button>
                        }
                        @if (workflowButtonConfig.showPositiveButton) {
                            <button
                                data-uiid="audit-positive-workflow-button"
                                class="btn btn-success"
                                (click)="onWorkflowButtonClick(true)"
                            >
                                {{ workflowButtonConfig.positiveButtonText }}
                            </button>
                        }
                    </span>
                </div>
            }
        </div>

        <div
            class="screens"
            [attr.name]="'detail.menuAudit' | t"
            menuicon="fal fa-clipboard-list-check"
            menusystemsubmenu
        >
            <div
                [attr.name]="'detail.menuDetails' | t"
                menuItemId="Details"
                menuicon="fas fa-info-circle"
                menusystemitem
            >
                <audit-detail-main
                    [auditModel]="auditModel"
                    [standingData]="standingData"
                    [formGroup]="formGroup"
                ></audit-detail-main>
            </div>
            @if (auditModel.id > 0) {
                <div
                    [attr.name]="'detail.menuRequests' | t"
                    [attr.menuItemId]="documentRequestsTabId"
                    menuicon="fas fa-user-clock"
                    menusystemitem
                >
                    <audit-detail-auditee-requests
                        #requests
                        [formGroup]="formGroup"
                        [permissions]="permissions"
                        [auditModel]="auditModel"
                        [cerrixTab]="cerrixTab"
                    ></audit-detail-auditee-requests>
                </div>
            }
            <div
                [attr.name]="'detail.menuContext' | t"
                [attr.menuItemId]="contextTabId"
                menuicon="fas fa-globe"
                menusystemitem
            >
                <audit-detail-context
                    #context
                    [formGroup]="formGroup"
                    [permissions]="permissions"
                    [auditModel]="auditModel"
                ></audit-detail-context>
            </div>
            @if (auditModel.id > 0) {
                <div
                    [attr.name]="'detail.menuRiskAssessment' | t"
                    [attr.menuItemId]="riskAssessmentTabId"
                    menuItemId="audit-risk-assessment"
                    menuicon="fad fa-th"
                    menusystemitem
                >
                    <audit-detail-risk-assessment
                        [permissions]="permissions"
                        [auditModel]="auditModel"
                        #riskAssessment
                    ></audit-detail-risk-assessment>
                </div>
                <div
                    [attr.name]="'detail.menuFieldworkPlan' | t"
                    menuItemId="audit-fieldwork-plan"
                    menuicon="fad fa-route"
                    menusystemitem
                >
                    <audit-detail-fieldwork-plan
                        [auditGuid]="auditModel.guid"
                        [permissions]="permissions"
                        [steps]="auditModel.fieldworkSteps"
                    ></audit-detail-fieldwork-plan>
                </div>
                <div
                    [attr.name]="'detail.menuFieldworkExecution' | t"
                    [attr.menuItemId]="fieldWorkExecutionTabId"
                    menuicon="fas fa-play"
                    menusystemitem
                >
                    <audit-detail-fieldwork-execution
                        [permissions]="permissions"
                        [auditGuid]="auditModel.guid"
                        #fieldworkExecutionComp
                    ></audit-detail-fieldwork-execution>
                </div>
                <div
                    [attr.name]="'detail.menuFindings' | t"
                    [attr.menuItemId]="findingsTabId"
                    menuicon="far fa-radar"
                    menusystemitem
                >
                    <audit-detail-finding-linking
                        [auditGuid]="auditModel.guid"
                        #findings
                    ></audit-detail-finding-linking>
                </div>
                <div
                    [attr.name]="'detail.menuFindingsReport' | t"
                    [attr.menuItemId]="findingReportTabId"
                    menuicon="fad fa-clipboard-list"
                    menusystemitem
                >
                    <audit-detail-finding-report-summary [auditModel]="auditModel" #findingReport>
                    </audit-detail-finding-report-summary>
                </div>
            }
            @if (
                permissions.canViewLinkedThirdParty ||
                permissions.canViewLinkedForms ||
                permissions.canViewDocuments
            ) {
                <div
                    class="h-auto"
                    [attr.name]="'detail.menuLinks' | t"
                    menuicon="fas fa-link"
                    menusystemsubmenu
                >
                    @if (permissions.canViewLinkedThirdParty) {
                        <div
                            [attr.name]="'detail.menuThirdParty' | t"
                            [attr.menuItemId]="thirdpartyTabId"
                            menuicon="fas fa-handshake"
                            menusystemitem
                        >
                            @if (auditModel) {
                                <audit-thirdparty
                                    [model]="auditModel"
                                    [disabled]="!permissions.canLinkThirdParty"
                                    #auditThirdParty
                                >
                                </audit-thirdparty>
                            }
                        </div>
                    }
                    @if (permissions.canViewLinkedForms) {
                        <div
                            [attr.menuItemId]="menuItemForms"
                            [attr.name]="'detail.menuForms' | t"
                            menuicon="fad fa-file-alt"
                            menusystemitem
                        >
                            <audit-linked-forms
                                #formsComponent
                                [model]="auditModel"
                                [disabled]="!permissions.canLinkForms"
                            ></audit-linked-forms>
                        </div>
                    }
                    @if (permissions.canViewDocuments) {
                        <div
                            [attr.name]="'detail.menuDocuments' | t"
                            menuItemId="audit-documents"
                            menuicon="far fa-file"
                            menusystemitem
                        >
                            <document-manager-folder
                                [cerrixTab]="cerrixTab"
                                [(Documents)]="auditModel.Documents"
                                [(Folders)]="auditModel.Folders"
                                [ParentGuid]="auditModel.guid"
                                [permissions]="permissions.documentPermissions"
                                [DocumentTypeTargets]="targetModule"
                                [ExtraFieldColumnConfig]="extraDocumentColumns"
                                [hideGenerateButton]="!enableDocumentComposing"
                            ></document-manager-folder>
                        </div>
                    }
                </div>
            }
            @if (auditModel.id > 0) {
                <div
                    class="h-auto"
                    [attr.name]="'detail.menuHistory' | t"
                    menuicon="fas fa-history"
                    menusystemsubmenu
                >
                    <div
                        [attr.name]="'detail.menuWorkflowHistory' | t"
                        menuicon="fas fa-history"
                        [attr.menuItemId]="workflowHistoryTabId"
                        menusystemitem
                    >
                        <audit-detail-workflow-history
                            #auditWorkflowHistory
                            [auditModel]="auditModel"
                        >
                        </audit-detail-workflow-history>
                    </div>
                    @if (auditModel.guid) {
                        <div
                            [attr.name]="'detail.menuAuditHistory' | t"
                            menusystemitem
                            [attr.menuItemId]="auditHistoryTabId"
                            menuicon="fas fa-history"
                        >
                            <app-history-overview
                                [historyDataService]="auditDataService"
                                [Id]="auditModel.guid"
                                #historyOverviewComponent
                            >
                            </app-history-overview>
                        </div>
                    }
                </div>
                <div
                    [attr.name]="'detail.menuOptions' | t"
                    menuItemId="Options"
                    menuicon="fas fa-check-double"
                    menusystemitem
                >
                    <detail-options
                        moduleName="audit"
                        [objectName]="auditModel.auditName"
                        [allowDelete]="true"
                        [buttonConfig]="buttonConfig"
                        (onDelete)="delete()"
                    >
                    </detail-options>
                </div>
            }
        </div>
    </div>
}
